import LIcon from "@components/LIcon";
import LPressable from "@components/LPressable";
import { OptionsMenuModalSWMSheet } from "@components/OptionsMenuModal/OptionsMenuModalSWM";
import { OptionsMenuModalProps } from "@components/OptionsMenuModal/types";
import { useCallback } from "react";
import { ViewStyle } from "react-native";
import { useBottomSheetManager } from "react-native-bottom-sheet-stack";

interface OptionsButtonProps extends OptionsMenuModalProps {
  iconSize?: number;
  sentryEventName: string;
  style?: ViewStyle;
}

const OptionsButton = ({
  activeSong,
  iconSize = 20,
  selectedCollection,
  selectedCatalogSong,
  sentryEventName,
  style,
}: OptionsButtonProps) => {
  const bottomSheetManager = useBottomSheetManager();
  const onPressOptions = useCallback(() => {
    bottomSheetManager.open(
      <OptionsMenuModalSWMSheet
        activeSong={activeSong}
        selectedCollection={selectedCollection}
        selectedCatalogSong={selectedCatalogSong}
      />,
      { mode: "push" },
    );
  }, [activeSong, bottomSheetManager, selectedCatalogSong, selectedCollection]);

  return (
    <>
      <LPressable
        onPress={onPressOptions}
        sentryEventName={sentryEventName}
        style={style}
        hitSlop={12}
      >
        <LIcon
          colors={{ color: selectedCatalogSong ? "greyText" : "white" }}
          name="ellipsis"
          size={iconSize}
        />
      </LPressable>
    </>
  );
};

export default OptionsButton;
